
import React, { Fragment, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { LocalizationContext } from 'app/localization/Context';
import { CurrentPageContext } from 'app/home/general-components/HistoryStackContext';
import { representOTAState } from '../../device/deivce-detail/OTAReport';
import { getDeviceTypeIcon } from '../../device/add-device/Config';

import { v4 as uuidv4 } from 'uuid';

import CustomIconBack from 'app/home/home-components/CustomIconBack';
import { ReactComponent as IconTick } from 'images/general/tick-white.svg';
import { ReactComponent as IconDownloadWhite } from 'images/general/download-white.svg';

import './MultiOTA.scss'

function getOTAIDForDevice(deviceMac) {
    return "web-app-mac-" + deviceMac;
}
// function parseOTAIDForDevice(otaID) {
//     if (otaID.includes("web-app-mac-")) {
//         const split = otaID.split("web-app-mac-");
//         if (split.length > 1) {
//             return split[1];
//         }
//     }
//     return undefined;
// }

export default function MultiOTA({ devices, otaProgressController, currentUser }) {
    const p = useContext(CurrentPageContext);
    const dismissHandler = p.dismiss;

    const l = useContext(LocalizationContext);
    const s = l.strings;
    const m = s.multiOTA;
    const o = s.otaReport;

    const otaPermission = currentUser.permissions.setting;

    const [multiOTAState, _setMultiOTAState] = useState({});
    const setMultiOTAState = useCallback((otaID, { phase, progress, progress_value }) => {
        _setMultiOTAState(s => {
            const ss = { ...s };
            ss[otaID] = { phase, progress, progress_value };
            return ss;
        })
    }, []);

    const notificationCallbackId = useState(uuidv4())[0];
    useEffect(() => {
        if ((otaProgressController !== undefined) && (otaProgressController.registerUniversalNotification !== undefined)) {
            otaProgressController.registerUniversalNotification(notificationCallbackId, setMultiOTAState);
        }
        return () => {
            if ((otaProgressController !== undefined) && (otaProgressController.unregisterUniversalNotification !== undefined)) {
                otaProgressController.unregisterUniversalNotification(notificationCallbackId);
            }
        }
    }, [otaProgressController, notificationCallbackId, setMultiOTAState]);

    const [touchedDevicesMac, setTouchedDevicesMac] = useState([]);

    const devicesToShow = useMemo(() => {
        const interestedDevicesMac = devices.filter(d => d.ota_exists === true).map(d => d.mac);
        for (let i = 0; i < touchedDevicesMac.length; i++) {
            const mac = touchedDevicesMac[i];
            if (!interestedDevicesMac.includes(mac)) {
                interestedDevicesMac.push(mac);
            }
        }
        const interestedDevices = devices.filter(d => interestedDevicesMac.includes(d.mac));
        const result = [];
        // add otaProgressRepresentaion to device
        for (let i = 0; i < interestedDevices.length; i++) {
            const device = { ...interestedDevices[i] };
            result.push(device);
            const otaID = getOTAIDForDevice(device.mac);
            if (Object.prototype.hasOwnProperty.call(multiOTAState, otaID)) {
                // console.log(device.mac, otaID, multiOTAState[otaID], representOTAState(o, l.localizeNumber, multiOTAState[otaID]));
                device.otaProgressRepresentaion = representOTAState(o, l.localizeNumber, multiOTAState[otaID]);
                // { error, mainIcon, title, info, isProgressActive, progressValue, progressTitle, progressFullText }
            }
        }
        return result;
    }, [o, devices, multiOTAState, touchedDevicesMac, l.localizeNumber]);
    const anyDeviceToShow = devicesToShow.length > 0;

    const startOTAForDevice = useCallback((device) => {
        setTouchedDevicesMac(l => {
            const ll = [...l];
            ll.push(device.mac);
            return ll;
        })
        device.startOTA(getOTAIDForDevice(device.mac))
    }, []);
    const startOTAForAllDevices = useCallback(() => {
        const interestedDevices = devices.filter(d => (d.ota_exists === true) && !touchedDevicesMac.includes(d.mac));
        const _touchedDevicesMac = [...touchedDevicesMac];
        for (let i = 0; i < interestedDevices.length; i++) {
            const device = interestedDevices[i];
            device.startOTA(getOTAIDForDevice(device.mac))
            _touchedDevicesMac.push(device.mac);
        }
        setTouchedDevicesMac(_touchedDevicesMac);
    }, [devices, touchedDevicesMac]);
    const anyNewDeviceToOTA = useMemo(() => {
        const interestedDevices = devices.filter(d => (d.ota_exists === true) && !touchedDevicesMac.includes(d.mac));
        return interestedDevices.length > 0;
    }, [devices, touchedDevicesMac]);

    // device.name
    // getDeviceTypeIcon(device.type).icon
    // device.roomName
    // device.otaProgressRepresentaion.mainIcon
    // device.otaProgressRepresentaion.progressFullText
    // width: String(device.otaProgressRepresentaion.progressValue) + "%"

    return (
        <div className="multi-ota-page">
            <div className="bg-blank" />
            <div className="bg-secondary-color" />
            <div className="multi-ota-page-content">
                <div className="nav-button" onClick={dismissHandler} />
                <div className="header-group">
                    <CustomIconBack className="back-icon" />
                    <div />
                    {
                        anyNewDeviceToOTA ? (
                            <div className="button-border"
                                onClick={startOTAForAllDevices}>
                                <div className="label">{m.updateAll}</div>
                                <IconDownloadWhite className="icon" />
                            </div>
                        ) : null
                    }
                </div>

                {/* title & info */}
                {anyDeviceToShow ?
                    <Fragment>
                        <div className="page-header with-margin-bottom">{m.title}</div>
                        {otaPermission ?
                            <div className="page-header-info">{m.info}</div> :
                            <div className="page-header-info important">{m.nonAdminInfo}</div>}
                    </Fragment>
                    :
                    <Fragment>
                        <div className="page-header">{m.title}</div>
                        <div className="nothing-to-ota">
                            <IconTick className="icon" />
                            <div className="label">{m.nothingToOTA}</div>
                        </div>
                    </Fragment>}

                <div className="devices">
                    {devicesToShow.map(device =>
                        <div className="device" key={"ota_row_of_device_" + device.mac}>
                            {React.createElement(getDeviceTypeIcon(device.type).icon, { className: "icon" })}
                            <div className="name-and-room">
                                <div className="name">{device.name}</div>
                                {device.roomName !== undefined ? <div className="room">{device.roomName}</div> : null}
                            </div>
                            {device.otaProgressRepresentaion !== undefined ?
                                <Fragment>
                                    <div className="progress-report">
                                        <div className="label">{
                                            device.otaProgressRepresentaion.isProgressActive ?
                                                device.otaProgressRepresentaion.progressFullText :
                                                device.otaProgressRepresentaion.title
                                        }</div>
                                        {React.createElement(device.otaProgressRepresentaion.mainIcon, { className: "icon" })}
                                    </div>
                                    {
                                        device.otaProgressRepresentaion.isProgressActive ?
                                            <div className="progress-line" style={{
                                                width: String(device.otaProgressRepresentaion.progressValue) + "%"
                                            }}></div> : null
                                    }
                                </Fragment>
                                :
                                <div className="button-with-border" onClick={() => { startOTAForDevice(device) }}>
                                    <div className="label">{m.update}</div>
                                    <IconDownloadWhite className="icon" />
                                </div>
                            }
                            {/* <div className="progress-line" style={{ width: "50%" }}></div> */}
                        </div>
                    )}
                </div>

            </div>
        </div>
    )
}
